import auth from "./auth";

import admin from "./admin";
import banner from "./banner";
import bannerPopup from "./bannerPopup";
import board from "./board";
import category from "./category";

import inquiry from "./inquiry";
import mainView from "./mainView";
import mainSector from "./mainSector";
import member from "./member";

import actionCitizen from "./actionCitizen";
import actionGroup from "./actionGroup";
import actionState from "./actionState";

import report from "./report";
import subscribe from "./subscribe";
import dashboard from "./dashboard";
import statistics from "./statistics";

import boardActionState from "./boardActionState";
import boardAction from "./boardAction";
import boardActionComment from "./boardActionComment";

import archives from "./archives";

import campainEvent from "./campainEvent";

export default {
    auth,
    admin,
    banner,
    bannerPopup,
    board,
    category,

    inquiry,
    mainView,
    mainSector,
    member,

    actionCitizen,
    actionGroup,
    actionState,

    report,
    subscribe,
    dashboard,
    statistics,
    boardActionState,
    boardAction,
    boardActionComment,

    archives,
    campainEvent,
};
